import type { HttpClient } from "@/shared/api/http";
import {
  completeOperation,
  startOperation,
  type CompleteOperationInput,
} from "@/modules/mes/api/mesApi";
import type { OfflineCommand } from "@/offline/types";

export type FlushCommandResult = {
  ok: boolean;
  errorMessage?: string;
};

export async function executeOfflineCommand(
  http: HttpClient,
  cmd: OfflineCommand,
): Promise<FlushCommandResult> {
  try {
    const payload = cmd.payload ? (JSON.parse(cmd.payload) as Record<string, unknown>) : {};
    switch (cmd.actionType) {
      case "MES_OP_START": {
        const operationId = String(payload.operationId ?? "");
        if (!operationId) {
          return { ok: false, errorMessage: "Thiếu operationId" };
        }
        const rawEq = payload.equipmentCode;
        const equipmentCode =
          typeof rawEq === "string" && rawEq.trim() ? rawEq.trim() : null;
        await startOperation(http, operationId, {
          clientRequestId: `offline-start-${operationId}-${Date.now()}`,
          equipmentCode,
        });
        return { ok: true };
      }
      case "MES_OP_COMPLETE": {
        const operationId = String(payload.operationId ?? "");
        if (!operationId) {
          return { ok: false, errorMessage: "Thiếu operationId" };
        }
        const input = payload.input as CompleteOperationInput | undefined;
        await completeOperation(http, operationId, input);
        return { ok: true };
      }
      default:
        return { ok: false, errorMessage: `Action không hỗ trợ: ${cmd.actionType}` };
    }
  } catch (e) {
    const msg = e instanceof Error ? e.message : "Sync thất bại";
    return { ok: false, errorMessage: msg };
  }
}
